import { toJS } from 'mobx';
import { QuestionFeedbackState } from '../../Constants';
import { Behavior } from './Behavior';
import UtilsService from '../services/UtilsService';

export class CauseAndEffectBehavior extends Behavior {
  checkForValidResponse = (responseAnswer, _model) => {
    const prompts = toJS(responseAnswer?.prompts || []);
    const hasSomeEmptyResponses = prompts.some?.(({ text } = {}) => !text);
    return !hasSomeEmptyResponses;
  }

  isAutoScored = (_model) => {
    return false;
    // const autoScore = ContentType.getAutoscore(model.type) && !model.survey && !model.unscored;
    // return autoScore;
  }

  setResponseData = ({ event, index }, responseAnswer, _model) => {
    if (index >= 0) {
      const value = event?.target?.value || '';
      const data = {
        id: `promptId${index}`,
        text: value
      };
      responseAnswer.prompts[index] = data;
    }
  }

  getInitializedResponse = (_lessonElementId, model, _activityId) => {
    const centerTextLength = 1;
    const leftTextLength = model.leftText?.length || 0;
    const rightTextLength = model.rightText?.length || 0;

    const promptsLength = centerTextLength + leftTextLength + rightTextLength;

    const prompts = Array(promptsLength).fill();

    // populate readonly 'center' prompts using the readonly (model.centerText) values
    prompts[0] = {
      id: `promptId${0}`,
      text: model.centerText || ''
    };
    // populate readonly 'left' prompts using the readonly (model.leftText) values
    for (let i = 0, j = centerTextLength; j < (promptsLength - rightTextLength); i++, j++) {
      prompts[j] = {
        id: `promptId${j}`,
        text: model.leftText[i] || ''
      };
    }
    // populate readonly 'right' prompts using the readonly (model.rightText) values
    for (let i = 0, j = (centerTextLength + leftTextLength); j < promptsLength; i++, j++) {
      prompts[j] = {
        id: `promptId${j}`,
        text: model.rightText[i] || ''
      };
    }

    const responseAnswer = {
      isScored: false,
      isScoredCorrect: false,
      prompts: [...prompts]
    };

    return responseAnswer;
  }

  getCorrectAnswersText = (_model) => {
    // method is unused by this response type
    return null;
  }

  setCorrectAnswer = (_state, _model) => {
    // this content type is not autoscored

  }

  resetStudentAnswer = (_state) => {
    // method is unused by this content type
    // state.currentResponseAnswer = UtilsService.safeMobxClone(state.cachedResponseAnswer);
  }

  getQuestionFeedbackText = (
    _model, _correctFeedback, _incorrectFeedback, _correctFeedbackBody, _incorrectFeedbackBody,
    _mode, _questionIsCorrect, _currentAttemptCount/* , { lessonElementState } */
  ) => {
    const textHeader = '';
    const textBody = UtilsService.saveCommit();

    let finalText = '<div class=\'question-feedback-header\'>';
    finalText += textHeader;
    finalText += '</div>';
    finalText += '<div class=\'question-feedback-body\'>';
    finalText += textBody;
    finalText += '</div>';

    return finalText;

    // TODO unused; this content type is not autoscored so we do not have this feedback
    // let textBody = '';
    // if (mode === LessonMode.PREVIEW || mode === LessonMode.STUDENT_PREVIEW || mode === LessonMode.PUBLISHER_PREVIEW) {
    //   textBody += UtilsService.previewWarning();
    // } else {
    //   if (typeof currentAttemptCount !== 'undefined' && currentAttemptCount !== -1 && currentAttemptCount>1) {
    //     textBody += UtilsService.saveWarning();
    //   } else {
    //     textBody += UtilsService.saveCommit();
    //   }
    // }

    // let textHeader = '';

    // if (questionIsCorrect === QuestionFeedbackState.CORRECT) {
    //   textHeader = correctFeedback;
    //   if (correctFeedbackBody) {
    //     textBody = correctFeedbackBody+' '+textBody;
    //   }
    // } else if ( questionIsCorrect ===  QuestionFeedbackState.PARTIAL_CORRECT ) {
    //   textHeader = `${UtilsService.partiallyCorrect()}`;
    //   let custom = '';
    //   if (incorrectFeedbackBody) {
    //     custom = incorrectFeedbackBody + ' ';
    //   }

    //   textBody = UtilsService.partiallyCorrectPrompt() + ' <br/>' + custom + textBody;
    // } else {
    //   textHeader = incorrectFeedback;
    //   if (incorrectFeedbackBody) {
    //     textBody = incorrectFeedbackBody+' '+textBody;
    //   }
    // }
  }

  isAnswerCorrect = (_answerId, lessonElementState, _model) => {
    if (lessonElementState.correctAnswerShowing) {
      return true;
    }

    return lessonElementState.isScored && (lessonElementState.submittedItemScore === lessonElementState.maxScore);
  }

  isQuestionCorrect = (lessonElementState) => {
    if (!lessonElementState) {
      return QuestionFeedbackState.INCORRECT;
    }
    if (lessonElementState.submittedItemScore >= lessonElementState.maxScore) {
      return QuestionFeedbackState.CORRECT;
    }
    if ((lessonElementState.submittedItemScore > 0) && (lessonElementState.submittedItemScore < lessonElementState.maxScore)) {
      return QuestionFeedbackState.PARTIAL_CORRECT;
    }
    return QuestionFeedbackState.INCORRECT;
  }
}

export default new CauseAndEffectBehavior();
